<template>
  <div class="app-logo" :style="{ justifyContent: centered ? 'center' : 'flex-start' }">
    <icon class="app-logo__icon" size="24" type="ios-leaf" :style="{ marginTop: onlyIcon ? 0 : '-8px' }" />
    <div style="margin-left: 4px" v-if="!onlyIcon">
      <span class="app-logo__text color ms-text">my</span>
      <span class="app-logo__text main">Surveys</span>
      <span class="app-logo__text color separator ms-text">|</span>
      <span class="app-logo__text color second ms-text">offers</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['centered', 'only-icon']
}
</script>

<style lang="less">
  .app-logo {
    line-height: 40px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    &__icon {
      &.ivu-icon {
        line-height: 40px;
        color: @primary-color;
      }
    }

    &__text {
      font-size: 14px;
      font-weight: bold;
      line-height: 40px;

      &.color {
        margin-left: 5px;

        &.second {
          margin-left: 0;
        }
      }
      &.separator {
        margin: 0 10px;
      }
      &.main {
        color: @primary-color;
      }
    }
  }
</style>
